export enum LiftLinkFormType {
    RetroFitForm = 0,
    AddOnForm = 1,
    SiteKitForm = 2,
  }
  